import application from 'application/application';

import template from './login.template.html';

import controller from './login.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.login', {
				views: {
					'root': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Login'
				},
				params: {
					authentication: false
				}
			});

	}]);
